import React, { Component, Fragment, useState } from 'react';
import { Row, Button } from 'reactstrap';
import ReactTable from 'react-table';
import Select from 'react-select';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DataTablePagination from '../../../../components/DatatablePagination';
import { Card, CardBody, CardTitle } from 'reactstrap';
import IntlMessages from '../../../../helpers/IntlMessages';
import {
  reactSelectOptionDiffrentPro,
  sortPropertyListByName,
} from '../../../../helpers/Utils';
import {
  getUserList,
  getRoleList,
  getPropertyList,
} from '../../../../redux/actions';
import {
  gAPI_Users_list,
  gAPI_Internal_Property_By_Id,
  postAPI_TrackEvent,
  gAPI_Internal_Property_List,
  gAPI_Search_Users_list,
  gAPI_Users_By_Id,
  gAPI_GetUsersAuditLogs_list,
  getAPI_SSO_By_GroupId,
} from '../../../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../../../helpers/AxiosAPI';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateInviteUsersForm from './components/forms/CreateInviteUsersForm';
import UpdateUsersForm from './components/forms/UpdateUsersForm';
import ReinviteUserForm from './components/forms/ReinviteUserForm';
import GenerateInvitationLink from './components/forms/GenerateInvitationLink';
import GenerateResetPasswordLink from './components/forms/GenerateResetPasswordLink';
import ContactsForm from './components/forms/ContactsForm';
import AuditLogsList from './components/forms/AuditLogsList';
import SignInLogs from './components/forms/SignInLogs';

// ─── Static Data ─────────────────────────────────────────────────────────────

const STATUS_OPTIONS = [
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Deleted', value: 'Deleted' },
];

const ROLE_OPTIONS = [
  { label: 'Admin', value: '2' },
  { label: 'Knowledge Manager', value: '3' },
  { label: 'Agent', value: '5' },
];

// Tab identifiers as constants — avoids magic strings scattered across the file
const TABS = {
  USERS: 'users',
  AUDIT_LOGS: 'auditLogs',
  SIGN_IN_LOGS: 'signInLogs',
};

// ─── Component ───────────────────────────────────────────────────────────────

class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: true,
      contacts: null,
      editContact: false,
      name: '',
      propertyList: [],
      allPropertyList: [],
      selectedProperty: [],
      selectedStatus: [
        { label: 'Active', value: 'Active' },
        { label: 'Pending', value: 'Pending' },
      ],
      selectedRoles: [],
      isFiltering: false,
      ssoStatus: '',
      activeTab: TABS.USERS, // ← Default tab: Users
    };
  }

  // ─── Lifecycle ─────────────────────────────────────────────────────────────

  componentDidMount() {
    this.fetchSSOStatus();
    this.trackPageEvent();
    this.fetchUsers();
    this.fetchUserProperties();
  }

  // ─── API Calls (unchanged logic, extracted for readability) ────────────────

  fetchSSOStatus = () => {
    AxiosAPI({
      method: 'get',
      url: `${getAPI_SSO_By_GroupId}?groupId=${getGroupID()}`,
    }).then((res) => {
      if (res.data?.status) {
        this.setState({ ssoStatus: res.data.status });
      }
    });
  };

  trackPageEvent = () => {
    if (this.props.email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Users and Admin',
          email: this.props.email,
        },
      }).then(
        () => {},
        (error) => console.log(error)
      );
    }
  };

  /**
   * Builds the filter query string for user search
   */
  buildUserFilterQuery = () => {
    const { selectedProperty, selectedStatus, selectedRoles } = this.state;
    const pid =
      selectedProperty.length > 0
        ? selectedProperty.map((a) => a.value).join('|')
        : '-1';
    const status =
      selectedStatus.length > 0
        ? selectedStatus.map((a) => a.value).join('|')
        : '-1';
    const roles =
      selectedRoles.length > 0
        ? selectedRoles.map((a) => a.value).join('|')
        : '-1';
    return `${gAPI_Search_Users_list}/${getGroupID()}?pid=${pid}&status=${status}&roles=${roles}`;
  };

  fetchUsers = () => {
    AxiosAPI({
      method: 'get',
      url: this.buildUserFilterQuery(),
    }).then(
      (res) => {
        this.setState({ data: res.data, isLoading: false });
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  fetchUserProperties = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((res) => {
      const userproperties = res.data.properties;

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Internal_Property_List}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          const allProps = res.data || [];
          this.setState({ allPropertyList: allProps });

          // Filter properties based on user's assigned properties
          const finalResult =
            userproperties.length > 0 && userproperties[0] === '-1'
              ? allProps
              : allProps.filter((p) => userproperties.includes(p.id));

          this.setState({ propertyList: finalResult, isLoading: false });
        })
        .catch((err) => console.log('err', err));

      if (this.props.propertyId !== '-1') {
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Internal_Property_By_Id}/${this.props.propertyId}?group_id=${getGroupID()}`,
        })
          .then((res) => {
            this.setState({ contacts: res.data.contacts, name: res.data.name });
          })
          .catch((err) => console.error(err));
      }
    });
  };

  // ─── Event Handlers ────────────────────────────────────────────────────────

  handleChangeSelect = (value, { name }) => {
    const keyMap = {
      property: 'selectedProperty',
      roles: 'selectedRoles',
      status: 'selectedStatus',
    };
    if (keyMap[name]) {
      this.setState({ [keyMap[name]]: value });
    }
  };

  handleSubmitClick = () => {
    AxiosAPI({
      method: 'get',
      url: this.buildUserFilterQuery(),
    }).then(
      (res) => {
        this.setState({ data: res.data, isLoading: false, isFiltering: false });
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  // ─── Table Columns ─────────────────────────────────────────────────────────

  getDataTableColumns = () => {
    const { ssoStatus } = this.state;
    const { serviceProvider } = this.props;

    const hideUserActions =
      ssoStatus === 'Active' &&
      (serviceProvider === '2' || serviceProvider === '5');

    return [
      {
        Header: 'Name',
        accessor: 'fullName',
        Cell: (props) => <p className="text-muted">{props.value}</p>,
      },
      {
        Header: 'Email',
        accessor: 'email',
        Cell: (props) => <p className="text-muted">{props.value}</p>,
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: (props) => <p className="text-muted">{props.value}</p>,
      },
      {
        Header: 'Role',
        accessor: 'roles',
        Cell: (props) => (
          <p className="text-muted">
            {props.value?.map((role, index) => (
              <Fragment key={index}>
                {role === 'User' ? 'Knowledge Manager' : role}
                <br />
              </Fragment>
            ))}
          </p>
        ),
      },
      {
        Header: '',
        accessor: 'userId',
        Cell: (props) => (
          <UpdateUsersForm id={props.value} ssoStatus={ssoStatus} />
        ),
      },
      {
        Header: '',
        accessor: 'email',
        Cell: (props) =>
          !hideUserActions && props.row.status !== 'Pending' ? (
            <GenerateResetPasswordLink
              email={props.value}
              id={props.row.userId}
            />
          ) : null,
      },
      {
        Header: '',
        accessor: 'userId',
        Cell: (props) =>
          !hideUserActions && props.row.status === 'Pending' ? (
            <ReinviteUserForm id={props.value} />
          ) : null,
      },
      {
        Header: '',
        accessor: 'userId',
        Cell: (props) =>
          !hideUserActions && props.row.status === 'Pending' ? (
            <GenerateInvitationLink id={props.value} />
          ) : null,
      },
    ];
  };

  // ─── Render Helpers ────────────────────────────────────────────────────────

  /**
   * Tab buttons row — highlights the active tab with solid vs outline style.
   * Uses TABS constants to avoid magic strings.
   */
  renderTabButtons = () => {
    const { activeTab, editContact, contacts, ssoStatus } = this.state;
    const { propertyId, serviceProvider } = this.props;

    const hideUserActions =
      ssoStatus === 'Active' &&
      (serviceProvider === '2' || serviceProvider === '5');

    return (
      <div className="mb-2">
        <Row>
          {/* ── Filter toggle ── */}
          {activeTab === TABS.USERS && (
            <div className="d-inline-block mt-2">
              <Button
                size="xs"
                color="primary"
                onClick={() =>
                  this.setState({ isFiltering: !this.state.isFiltering })
                }
              >
                <div className="d-flex">
                  <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
                  <IntlMessages id="menu.show-filter" />
                  <div className="ml-1" style={{ marginTop: '2px' }}>
                    {this.state.isFiltering ? (
                      <i className="simple-icon-arrow-up p-1" />
                    ) : (
                      <i className="simple-icon-arrow-down p-1" />
                    )}
                  </div>
                </div>
              </Button>
            </div>
          )}
          {/* ── Subscribe to Reports (only when a property is selected) ── */}
          {propertyId !== '-1' && (
            <div className="d-block d-md-inline-block mt-2 ml-2">
              <Button
                color="primary"
                outline
                size="xs"
                onClick={() => this.setState({ editContact: true })}
                className="top-right-button mr-1"
              >
                + Subscribe to Reports
              </Button>

              {editContact && (
                <ContactsForm
                  contacts={contacts}
                  id={propertyId}
                  name={this.state.name}
                  visible={editContact}
                  toggle={() => this.setState({ editContact: !editContact })}
                />
              )}
            </div>
          )}

          {/* ── Invite Users (hidden when SSO active with certain providers) ── */}
          {!hideUserActions && (
            <div className="mb-2 d-inline-block ml-2 mt-2">
              <CreateInviteUsersForm />
            </div>
          )}

          {/* ── Tab: Users ── */}
          <div className="mb-2 d-inline-block ml-2 mt-2">
            <Button
              color="primary"
              // Solid when active, outline when inactive — gives clear visual feedback
              outline={activeTab !== TABS.USERS}
              size="xs"
              onClick={() => this.setActiveTab(TABS.USERS)}
              className="top-right-button mr-1"
            >
              Users
            </Button>
          </div>

          {/* ── Tab: Change Logs ── */}
          <div className="mb-2 d-inline-block ml-2 mt-2">
            <Button
              color="primary"
              outline={activeTab !== TABS.AUDIT_LOGS}
              size="xs"
              onClick={() => this.setActiveTab(TABS.AUDIT_LOGS)}
              className="top-right-button mr-1"
            >
              Change Logs
            </Button>
          </div>

          {/* ── Tab: Sign-in Logs ── */}
          <div className="mb-2 d-inline-block ml-2 mt-2">
            <Button
              color="primary"
              outline={activeTab !== TABS.SIGN_IN_LOGS}
              size="xs"
              onClick={() => this.setActiveTab(TABS.SIGN_IN_LOGS)}
              className="top-right-button mr-1"
            >
              Sign-in Logs
            </Button>
          </div>
        </Row>
      </div>
    );
  };

  /**
   * Filter panel — only shown when isFiltering is true.
   */
  renderFilterPanel = () => {
    const {
      isFiltering,
      propertyList,
      selectedProperty,
      selectedStatus,
      selectedRoles,
    } = this.state;

    if (!isFiltering) return null;

    return (
      <Card
        className="filter-width mt-2"
        style={{
          position: 'absolute',
          zIndex: '1',
          top: '7rem',
          marginLeft: '0rem',
          boxShadow:
            '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
        }}
      >
        <CardBody>
          <Colxx md="12">
            <Row>
              <Colxx xxs="12" md="12" className="mb-2">
                <Select
                  isMulti
                  className="react-select"
                  classNamePrefix="react-select"
                  name="property"
                  placeholder="Property"
                  onChange={this.handleChangeSelect}
                  options={
                    propertyList?.length > 0
                      ? reactSelectOptionDiffrentPro(
                          sortPropertyListByName(propertyList),
                          true,
                          'id',
                          'name',
                          'All Properties'
                        )
                      : []
                  }
                  value={selectedProperty}
                />
              </Colxx>

              <Colxx xxs="12" md="12" className="mb-2">
                <Select
                  isMulti
                  className="react-select"
                  classNamePrefix="react-select"
                  name="status"
                  placeholder="Status"
                  onChange={this.handleChangeSelect}
                  options={reactSelectOptionDiffrentPro(
                    STATUS_OPTIONS,
                    true,
                    'value',
                    'label',
                    'Select Status'
                  )}
                  value={selectedStatus}
                />
              </Colxx>

              <Colxx xxs="12" md="12" className="mb-2">
                <Select
                  isMulti
                  className="react-select"
                  classNamePrefix="react-select"
                  name="roles"
                  placeholder="Roles"
                  onChange={this.handleChangeSelect}
                  options={reactSelectOptionDiffrentPro(
                    ROLE_OPTIONS,
                    true,
                    'value',
                    'label',
                    'Roles'
                  )}
                  value={selectedRoles}
                />
              </Colxx>

              <Colxx xxs="12" md="12">
                <Button
                  size="xs"
                  color="primary"
                  className="mb-2 mt-2"
                  onClick={this.handleSubmitClick}
                >
                  Search
                </Button>
                <Button
                  size="xs"
                  color="secondary"
                  className="mb-2 ml-2 mt-2"
                  onClick={() => this.setState({ isFiltering: false })}
                >
                  <IntlMessages id="pages.cancel" />
                </Button>
              </Colxx>
            </Row>
          </Colxx>
        </CardBody>
      </Card>
    );
  };

  /**
   * Single source of truth for which tab body to render.
   * FIX: Sign-in Logs no longer gated behind propertyList.length > 0 —
   *      that check was preventing render even when data was available.
   */
  renderActiveTab = () => {
    const { activeTab, data, isLoading, allPropertyList } = this.state;

    switch (activeTab) {
      case TABS.USERS:
        return (
          <Colxx xxs="12" className="mb-2">
            <Card className="mb-2">
              <CardBody>
                {!isLoading && data ? (
                  <ReactTable
                    data={Array.isArray(data) ? data : []}
                    columns={this.getDataTableColumns()}
                    defaultPageSize={10}
                    filterable={false}
                    showPageJump={true}
                    PaginationComponent={DataTablePagination}
                    showPageSizeOptions={true}
                  />
                ) : (
                  <div className="loading" />
                )}
              </CardBody>
            </Card>
          </Colxx>
        );

      case TABS.AUDIT_LOGS:
        return (
          <AuditLogsList
            logType="UsersRoles"
            visible={true}
            toggle={() => this.setActiveTab(TABS.USERS)}
          />
        );

      case TABS.SIGN_IN_LOGS:
        return (
          <SignInLogs
            logType="SignInLogs"
            visible={true}
            groupId={getGroupID()}
            propertyList={allPropertyList}
            toggle={() => this.setActiveTab(TABS.USERS)}
          />
        );

      default:
        return null;
    }
  };

  // ─── Main Render ───────────────────────────────────────────────────────────

  render() {
    return (
      <Fragment>
        {/* Tab buttons + action buttons */}
        {this.renderTabButtons()}

        <Colxx xxs="12" className="mb-2 text-right">
          <strong>
            <hr />
          </strong>
        </Colxx>

        {/* Filter panel (absolute positioned dropdown) */}
        {this.renderFilterPanel()}

        {/* Active tab content */}
        {this.renderActiveTab()}
      </Fragment>
    );
  }
}

// ─── Redux ─────────────────────────────────────────────────────────────────

const mapStateToProps = ({ settings }) => {
  const { propertyId, email, serviceProvider } = settings;
  return { propertyId, email, serviceProvider };
};

export default injectIntl(
  connect(mapStateToProps, {
    getUserList,
    getRoleList,
    getPropertyList,
  })(AdminPage)
);
